import React from 'react';

/**
 * Simple cookie consent banner for analytics.
 * Props:
 * - onAccept: () => void
 * - onDecline: () => void
 */
export default function CookieConsent({ onAccept, onDecline }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-5xl p-4">
        <div className="rounded-lg border border-gray-200 bg-white/95 backdrop-blur shadow-lg dark:border-gray-700 dark:bg-gray-800/95">
          <div className="p-4 sm:p-5">
            <p className="text-sm text-gray-700 dark:text-gray-200">
              Vi använder endast analys-cookies med ditt samtycke för att förbättra upplevelsen. Du kan acceptera eller avvisa analys-cookies.
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={onDecline}
                className="inline-flex items-center rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
              >
                Avvisa
              </button>
              <button
                type="button"
                onClick={onAccept}
                className="inline-flex items-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
              >
                Acceptera
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
